<template>	
	<Select v-if="type=='select'" v-model="str" :placement="placement" :transfer="transfer" :size="size" :placeholder="placeholder" :disabled="disabled" :label-in-value="true" :clearable="clearable" @on-change="callback" @on-clear="clearit()">
        <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
	<Cascader v-else-if="type=='cascade'" :data="list" v-model="arr" :disabled="disabled" @on-change="callback"></Cascader>
	<CheckboxGroup class="gyl-checkbox-group" v-else-if="type=='checkbox'" v-model="arr" :size="size" @on-change="callback">
        <Checkbox class="gyl-checkbox" v-for="item in list" :key="item.value" :label="item.value" :disabled="disabled">
            <span>{{ item.label }}</span>
        </Checkbox>        
    </CheckboxGroup>
	<RadioGroup class="gyl-radio-group" v-else-if="type=='radio'" v-model="str" :size="size" :vertical="vertical" @on-change="callback">
        <Radio class="gyl-radio" v-for="item in list" :key="item.value" :label="item.value" :disabled="disabled">           
            <span>{{ item.label }}</span>
        </Radio>        
    </RadioGroup>
	<RadioGroup v-else-if="type=='radioBtn'" v-model="str" type="button" :size="size" :vertical="vertical" @on-change="callback">
        <Radio v-for="item in list" :label="item.value" :key="item.value" :disabled="disabled">           
            <span>{{ item.label }}</span>
        </Radio>        
    </RadioGroup>	
</template>
<script>
import {eqObj} from '@/libs/fn.js';
export default {
	name: 'dictag',
	props: {
		value: {
			type: [String, Number, Array],
			default: ''
		},
		type: {
			type: String,
			default:'select'
		},
		placement:{
			type: String,
			default:'bottom-start'
		},
		size: {
			type: String,
			default:'default' 
		},
		disabled: {
			type: Boolean,
			default:false
		},
		clearable: {
			type: Boolean,
			default:false
		},
		vertical: {
			type: Boolean,
			default:false
		},
		placeholder: {
			type: String,
			default:'请选择'
		},
		url: {
			type: String,
			default:''
		},
		query:{//
			type: Object,
            default:() => ({}) 
		},
		transfer: {
			type: Boolean,
			default:false
		},
	},
	data () {
		return {
			str:'',
			arr:[],
			list:[],
			cQuery:{},
			corporation:this.$store.state.user.user.corporation||''
		}
	},
	watch: {
		'value' (value) {
			this.getVal(value)
		},
		'query' (obj) {
			if(!eqObj(obj,this.cQuery)){
				this.cache(obj);
				this.getList();
			}			
		}	
	},
	mounted(){			
		this.getVal(this.value);
		this.cache(this.query);
		this.getList();
	},
	methods: {
		clearit(){
			if(this.type=="select") 
			{
				this.$emit('clear',this.value);
			}
		},
		cache(obj){this.cQuery=obj},
		getVal(val){
			if(this.type=="select"||this.type=="radioBtn"||this.type=="radio"){
				this.str = val;				
			}else{
				this.arr = val.split(",");
			}			
		},
		getList(){
			var query = Object.assign({},{corporation:this.corporation},this.query);
			this.$ajax.post(this.url,query).then(data => {
				if(data.status==this.$ajax.HTTP_S){
					this.list = data.result;
				}
				
			});	
			
		},
		callback(o){
			// console.log("0",o.value)
			if(this.type=="select") this.$emit('callback',o?o.value:'');
			if(this.type=="cascade") this.$emit('callback',o.join());
			if(this.type=="checkbox"){
				let v = o.join().split(",");
				if(v[0]=='') v.splice(0,1);				
				this.$emit('callback',v.join());
			}
			if(this.type=="radio"||this.type=="radioBtn") this.$emit('callback',o);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inc/dictionary/dictag.vue